module.exports = __webpack_public_path__ + "img/logo.4195c2b0.svg";